import React from 'react';
import PropTypes from 'prop-types';

import {Input, Button} from '../../styles';
import {GridContainer, GridCell} from '../../grid';

function OfficeForm({office, areaReferences, handleChange, dialogData, setDialogData, dialogOpen, setDialogOpen}) {
  return (
    <div>
      <Input
        name="name"
        palette='secondary'
        label="Office Name"
        type="text"
        value={office?.name || ''}
        onChange={(value) => handleChange('name', value)}
      />

      <GridContainer>
        <GridCell weight={1}>
          <Input
            disabled={true}
            name="area"
            palette='secondary'
            label="Operational Area"
            type="text"
            value={office?.area ? areaReferences[office?.area]?.name || '...processing' : 'No area selected'}
          />
        </GridCell>
        <GridCell style={{marginTop: 7}}>
          <Button palette='primary' onClick={() => {
            setDialogData({
              type: 'changeArea',
              title: 'Change Area',
              data: {
                callback: (value) => {
                  handleChange('area', value);
                }
              },
              value: {
                expandSearch: false,
              }
            });
            setDialogOpen(true);
          }}>
            Change Area
          </Button>
        </GridCell>
      </GridContainer>
      <Input
        name="email"
        palette='secondary'
        label="Enquiry Email"
        type="text"
        value={office?.email || ''}
        onChange={(value) => handleChange('email', value)}
      />
      <Input
        name="phone"
        palette='secondary'
        label="Enquiry Phone"
        type="text"
        value={office?.phone || ''}
        onChange={(value) => handleChange('phone', value)}
      />
    </div>
  );
}

OfficeForm.propTypes = {
  office: PropTypes.shape({}),
  areaReferences: PropTypes.shape({}),
  handleChange: PropTypes.func,
}

export default OfficeForm;
